function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { NoAction } from './NoAction';
import { SelectAll } from './SelectAll';
import { ActionList } from '../ActionList';
import { Button } from '../Button';
import { Text } from '../Text';
import useIsMobile from '../Utils/customHooks/useIsMobile';
import styles from '@dtsl/css-bulk-action/dist/index.module.css';
function BulkAction(props) {
  var _primaryActions$slice;
  const {
    className = '',
    selectedDataCount = 0,
    totalDataCount = 0,
    moreActionsMetaData = {},
    selectAllButtonProps = {
      label: 'Select All',
      ariaLabel: 'Select All',
      onClick: () => {}
    },
    primaryActions = [],
    mobilePrimaryActions = [],
    noActionsText = '',
    mobileNoActionsText = ''
  } = props;
  const {
    isMobile
  } = useIsMobile(640);
  const bulkActionRef = useRef();
  const bulkActionClass = classNames({
    [styles['sib-bulk-action']]: true,
    [className]: !!className
  });
  return /*#__PURE__*/React.createElement("div", {
    className: bulkActionClass,
    ref: bulkActionRef
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['sib-bulk-action__select']
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    size: "lg",
    tag: "span",
    fontFamily: "bold"
  }, selectedDataCount), "/", /*#__PURE__*/React.createElement("span", null, totalDataCount)), /*#__PURE__*/React.createElement(SelectAll, {
    selectAllButtonProps: selectAllButtonProps,
    variant: "tertiary"
  })), primaryActions.length === 0 && ((moreActionsMetaData === null || moreActionsMetaData === void 0 ? void 0 : moreActionsMetaData.options) || []).length === 0 ? /*#__PURE__*/React.createElement(NoAction, {
    noActionsText: noActionsText,
    mobileNoActionsText: mobileNoActionsText
  }) : isMobile ? /*#__PURE__*/React.createElement(ActionList, _extends({}, moreActionsMetaData, {
    options: [...mobilePrimaryActions.options, ...moreActionsMetaData.options]
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, (_primaryActions$slice = primaryActions.slice(0, 3)) === null || _primaryActions$slice === void 0 ? void 0 : _primaryActions$slice.map((buttonProps, index) => {
    return /*#__PURE__*/React.createElement(Button, _extends({
      key: index
    }, buttonProps, {
      variant: "tertiary"
    }));
  }), /*#__PURE__*/React.createElement(ActionList, moreActionsMetaData)));
}
BulkAction.propTypes = {
  className: PropTypes.string,
  selectedDataCount: PropTypes.number,
  totalDataCount: PropTypes.number,
  moreActionsMetaData: PropTypes.object,
  selectAllButtonProps: PropTypes.object,
  primaryActions: PropTypes.array,
  mobilePrimaryActions: PropTypes.object,
  noActionsText: PropTypes.string,
  mobileNoActionsText: PropTypes.string
};
export default BulkAction;